import styled from "@emotion/styled";
import { Icon, Input } from "semantic-ui-react";

const StyledInput = styled(Input)({
    marginBottom: '16px'
})

interface Props {
    name?: string;
    email?: string;
    size?: number;
    onNameChange: (name: string) => unknown;
}

const UserInfoSection = ({ name, email, onNameChange }: Props) => {
    return (
        <section id="user-info" className="flex flex-col">
            <h4>
                Your Information
            </h4>
            <StyledInput
                type="text"
                value={name}
                icon={() => <Icon name='user' color="red" />}
                iconPosition='left'
                onChange={(e) => {
                    onNameChange(e.target.value);
                }}
            />
            <StyledInput
                type="text"
                value={email}
                disabled
                icon={() => <Icon name='mail' color="red" />}
                iconPosition='left'
            />
        </section>
    );
};

export default UserInfoSection;
